



class Rules {}

Rules.required = (data = {}) => {
  return {
    required: true,
    message: '该项为必填项',
    trigger: data.trigger ? data.trigger : 'blur'
  }
}

Rules.number = (data = {}) => {
  const message = '必须为数字'
  const validator = function (rule,value,callback) {
    if(Object.is(Number(value),NaN)) {
      callback(new Error(message))
    }else {
      callback()
    }
  }
  return {validator,trigger: data.trigger ? data.trigger : 'blur'}
}

Rules.strLength = (data = {}) => {
  const message = `请输入${data.length}位长度`
  const validator = function (rule,value,callback) {
    if(value.length !== data.length) {
      callback(new Error(message))
    }else {
      callback()
    }
  }
  return {validator,trigger: data.trigger ? data.trigger : 'blur'}
}

Rules.validate = dom => {
  return new Promise((resolve,reject) => {
    dom.validate(valid => {
      if(valid) {
        resolve()
      }else {
        reject({
          code: 500,
          message: '表单有误'
        })
      }
    })
  })
}


export default Rules


// WEBPACK FOOTER //
// ./src/util/rules.js